var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1.125A1.125 1.125 0 0 1 1.125 0h2.422a1.125 1.125 0 0 1 1.11.94l.832 4.99a1.125 1.125 0 0 1-.608 1.192l-1.741.87a12.42 12.42 0 0 0 6.868 6.868l.87-1.741a1.125 1.125 0 0 1 1.192-.608l4.99.833a1.125 1.125 0 0 1 .94 1.109v2.422A1.125 1.125 0 0 1 16.875 18h-2.25C6.547 18 0 11.453 0 3.375z"
  })));
};
export default SvgIconPhone;